"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const AssignmentTurnedIn_1 = __importDefault(require("@mui/icons-material/AssignmentTurnedIn"));
const FilterList_1 = __importDefault(require("@mui/icons-material/FilterList"));
const styles_1 = require("@mui/material/styles");
const mui_1 = require("tss-react/mui");
const styles = ({ palette, spacing }) => ({
    root: {
        paddingRight: spacing(1),
        minHeight: 30,
    },
    highlight: palette.mode === 'light'
        ? {
            color: palette.secondary.main,
            backgroundColor: (0, styles_1.lighten)(palette.secondary.light, 0.85),
        }
        : {
            color: palette.text.primary,
            backgroundColor: palette.secondary.dark,
        },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});
const useStyles = (0, mui_1.makeStyles)()(styles);
const QListToolbar = ({ numSelected, onDelete, onRequestCreate, onValidateRequest, listName }) => {
    const { classes } = useStyles();
    return (<Toolbar_1.default className={(0, classnames_1.default)(classes.root, {
            [classes.highlight]: numSelected > 0,
        })}>
      <div className={classes.title}>
        {numSelected > 0 && (<Typography_1.default color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography_1.default>)}
      </div>
      {numSelected === 0 &&
            <>
          <Tooltip_1.default title="Create new item">
            <IconButton_1.default aria-label="Create New Item" color="primary" className={classes.newButton} onClick={onRequestCreate} id={`create-new-${listName}`} size="large">
              <Add_1.default viewBox="0 0 24 24"/>
            </IconButton_1.default>
          </Tooltip_1.default>
          {onValidateRequest && (<Tooltip_1.default title="Validate Data">
              <IconButton_1.default aria-label="Validate Data" color="primary" className={classes.newButton} onClick={onValidateRequest} id={`validate-${listName}`} size="large">
                <AssignmentTurnedIn_1.default viewBox="-3 -5 30 30"/>
              </IconButton_1.default>
            </Tooltip_1.default>)}
        </>}

      <div className={classes.spacer}/>

      <div className={classes.actions}>
        {numSelected > 0 ? (<Tooltip_1.default title="Delete">
            <IconButton_1.default aria-label="Delete" onClick={onDelete} id="delete-button" size="large">
              <Delete_1.default />
            </IconButton_1.default>
          </Tooltip_1.default>) : (<div>
            <Tooltip_1.default title="Filter list">
              <IconButton_1.default aria-label="Filter list" id="filter-button" size="large">
                <FilterList_1.default />
              </IconButton_1.default>
            </Tooltip_1.default>
          </div>)}
      </div>
    </Toolbar_1.default>);
};
exports.default = QListToolbar;
